import styled, { css } from "styled-components";
import { Drawer, Button as AntButton, Table as AntTable } from "antd";

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 1rem;
  }

  .ant-drawer-mask {
    z-index: 1000;
  }

  &.ant-drawer-open {
    z-index: 1000;
  }

  .ant-drawer-content-wrapper {
    z-index: 1000;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 1.5rem;
`;

export const UsersListContainer = styled.div``;

export const UsersListTitle = styled.h3`
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 1rem;
  color: #333;
  display: flex;
  align-items: center;
`;

export const UsersCount = styled.span`
  margin-left: 0.5rem;
  font-weight: normal;
  color: #666;
`;

export const CoursesContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const CoursesTitle = styled.h3`
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 1rem;
  color: #333;
`;

export const StyledTable = styled(AntTable)`
  .ant-table-tbody > tr > td {
    padding: 0.5rem 1rem;
  }

  .ant-table-thead > tr > th {
    background-color: #f0f0f0;
    color: #333;
    font-weight: 500;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 12.5rem;
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
`;

interface ButtonProps {
  type: "primary" | "default";
}

export const Button = styled(AntButton)<ButtonProps>`
  border-radius: 0.3rem;
  ${({ type }) => {
    if (type === "primary") {
      return css`
        background-color: var(--orange-150);
        &&&:hover,
        &&&:focus,
        &&&:active,
        &&&:focus-within {
          background-color: rgb(255, 132, 0);
        }
      `;
    }
    if (type === "default") {
      return css`
        background-color: var(--gray-100);
        &&&:hover,
        &&&:focus,
        &&&:active,
        &&&:focus-within {
          background-color: rgb(209, 209, 209);
          color: #333;
        }
      `;
    }
  }}
`;

export const EmptyContainer = styled.div`
  height: 12.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
